export const GROW_NETWORK_COPY = {
  referrer: {
    headline: "The bigger your network, the more you earn",
    supporting:
      "Import your contacts and grow your referral pool. More connections = more Tier 3 jobs you can fill.",
  },
  job_seeker: {
    headline: "Get discovered faster",
    supporting:
      "When more people in your industry are on Workbrook, you are more likely to be referred for the right role.",
  },
  employer: {
    headline: "Your jobs travel further",
    supporting:
      "A bigger referral pool means your Tier 3 postings reach more qualified candidates, faster.",
  },
};

/**
 * Derive Grow Your Network persona from user data + stats.
 * Note: account_type "referral" users often have user_type "1" (can post);
 * do not treat user_type alone as employer.
 */
export function getGrowNetworkPersona(userData, stats = {}) {
  if (userData?.account_type === "business") {
    return "employer";
  }
  if (stats?.has_referred || (stats?.invites_sent || 0) > 0) {
    return "referrer";
  }
  return "job_seeker";
}

export const NDPA_CONSENT_TEXT =
  "By importing contacts, you confirm you have permission to share their information with Workbrook for the purpose of inviting them to the platform. Imported contact data (name and email) is stored only for matching and invite purposes, is not shared with other users or third parties, and may be deleted from your account settings at any time. This complies with the Nigeria Data Protection Act (NDPA) 2023.";
